export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE"

export const Get_Product_Success = "Get_Product_Success"

export const Patch_Product_Success = "Patch_Product_Success"